(function () {
  const FILTERS_ID = 'FacetDrawer';
  const STICKY_FILTERS_ID = 'FacetDrawerSticky';
  
  const SLIDER_SELECTOR = '.filter-slider';
  const SLIDER_BUTTON_SELECTOR = '.filter-slider__button';
  const SLIDER_BUTTON_MIN_SELECTOR = '.filter-slider__button_min';
  const SLIDER_BUTTON_MAX_SELECTOR = '.filter-slider__button_max';

  const ACTIVE_CHOICE_BUTTON_CLASS = 'filter-choice__btn_active';

  let pressedSliderButton = null;

  function isMobile () {
    return document.documentElement.clientWidth < 1280;
  }
  
  function getDrawerId (child) {
    return child.closest('.facet-drawer').id;
  }

  function getFilterName (child) {
    return child.closest('.filter-range').dataset.name;
  }

  function getFilterTitle (child) {
    return child.closest('.filter-range').dataset.title;
  }

  function getFilterFromValue (filter) {
    return parseFloat(filter.querySelector('[data-from-input]').value);
  }
  
  function getFilterToValue (filter) {
    return parseFloat(filter.querySelector('[data-to-input]').value);
  }

  function getFilterMaxValue (filter) {
    return parseFloat(filter.querySelector('[data-to-input]').getAttribute('max'));
  }

  function getLeftTouchOffset (slider, touchPosition) {
    return touchPosition - slider.getBoundingClientRect().left;
  }
  
  function getRightTouchOffset (slider, touchPosition) {
    return slider.getBoundingClientRect().right - touchPosition;
  }

  function getMaxAllowedOffset (slider, left) {
    const oppositeOffset = parseInt(left ? slider.style.borderRightWidth : slider.style.borderLeftWidth) || 0;
    return slider.offsetWidth - oppositeOffset;
  }

  class SliderFilter {
    type;
    name;
    title;
    from;
    to;
    max;

    constructor (params) {
      for (let key in params) {
        this[key] = params[key];
      }
    }

    get slider () {
      return document.body.querySelector(`#${this.type} .filter-range[data-name="${this.name}"] .filter-slider`);
    }

    get sliderWidth () {
      return this.slider?.offsetWidth;
    }

    get leftOffset () {
      return this.from / this.max * this.sliderWidth;
    }

    get rightOffset () {
      return (1 - this.to / this.max) * this.sliderWidth;
    }

    get isActive () {
      return this.from !== 0 || this.to !== this.max;
    }

    get urlToRemove () {
      const url = new URL(window.location.href);
      url.searchParams.delete(this.name);
      return url.toString();
    }

    get label () {
      return this.from === this.to ? `${this.title}: ${this.from}` : `${this.title}: ${this.from} - ${this.to}`;
    }

    fixValues () {
      if (this.from <= this.to) {
        return;
      }

      const tmp = this.from;
      this.from = this.to;
      this.to = tmp;
    }

    setFromByOffset (offset) {
      this.from = Math.round(offset / this.sliderWidth * this.max);
      this.render();
    }

    setToByOffset (offset) {
      this.to = Math.round((1 - offset / this.sliderWidth) * this.max);
      this.render();
    }

    reset () {
      this.from = 0;
      this.to = this.max;
      this.render();
    }

    render () {
      const slider = this.slider;
      slider.style.borderLeftWidth = `${this.leftOffset}px`;
      slider.style.borderRightWidth = `${this.rightOffset}px`;
  
      const sliderParent = slider.parentElement;
      sliderParent.querySelector('[data-from-input]').value = this.from;
      sliderParent.querySelector('[data-to-input]').value = this.to;
    }
  }

  function initFilters () {
    return [...document.body.querySelectorAll('.filter-range')].map(filter => {
      return new SliderFilter({
        type: getDrawerId(filter),
        name: getFilterName(filter),
        title: getFilterTitle(filter),
        from: getFilterFromValue(filter),
        to: getFilterToValue(filter),
        max: getFilterMaxValue(filter)
      });
    });
  }
  
  function onMouseDown (e) {
    const target = e.target;
    if (!target.matches(SLIDER_BUTTON_SELECTOR)) {
      return;
    }

    if (target.matches(SLIDER_BUTTON_MIN_SELECTOR)) {
      pressedSliderButton = target;
      return;
    }

    const slider = target.parentElement;
    const isTotalRightPosition = parseInt(slider.style.borderLeftWidth) === parseInt(slider.offsetWidth);
    pressedSliderButton = isTotalRightPosition ? slider.querySelector(SLIDER_BUTTON_MIN_SELECTOR) : target;
  }

  function onMouseMove (e) {
    if (!pressedSliderButton) {
      return;
    }

    const position = e.touches?.length ? e.touches[0].clientX : e.clientX;
    if (!position) {
      return
    }

    const slider = pressedSliderButton.parentElement;
    const isLeftButton = pressedSliderButton.matches(SLIDER_BUTTON_MIN_SELECTOR);
    const offset = isLeftButton ? getLeftTouchOffset(slider, position) : getRightTouchOffset(slider, position);
    const fixedOffset = Math.min(Math.max(offset, 0), getMaxAllowedOffset(slider, isLeftButton));

    if (isLeftButton) {
      setSliderFromValue(slider, fixedOffset);
    } else {
      setSliderToValue(slider, fixedOffset);
    }
  }

  function onMouseUp () {
    if (!pressedSliderButton) {
      return;
    }

    selectCheckboxesBySlider(pressedSliderButton.parentElement);
    pressedSliderButton = null;
  }

  function setSliderFromValue (slider, offset) {
    getFilterState(slider).setFromByOffset(offset);
  }

  function setSliderToValue (slider, offset) {
    getFilterState(slider).setToByOffset(offset);
  }

  function getFilterState (child) {
    const drawerId = getDrawerId(child);
    const name = getFilterName(child);
    return rangeFilters.find(filter => filter.type === drawerId && filter.name === name);
  }

  function selectCheckboxesBySlider (slider) {
    const sliderSection = slider.closest('.details__content');
    const checkboxes = [...sliderSection.querySelectorAll('input[type="checkbox"]')];
    
    const min = parseFloat(sliderSection.querySelector('[data-from-input]').value);
    const max = parseFloat(sliderSection.querySelector('[data-to-input]').value);

    const checkboxGroups = groupCheckboxes(checkboxes, min, max);
    checkboxGroups.check.forEach(c => {
      c.checked = true;
    });
    checkboxGroups.uncheck.forEach(c => {
      c.checked = false;
    });

    const event = new Event('change', {view: window, bubbles: true, cancelable: true});
    checkboxes[0].dispatchEvent(event);
  }

  function dispatchChangeEvent (elem) {
    const event = new Event('change', {view: window, bubbles: true, cancelable: true});
    elem.dispatchEvent(event);
  }

  function groupCheckboxes (checkboxes, min, max) {
    const result = {uncheck: [], check: []};

    result.check = getCheckboxesToCheck(checkboxes, min, max);
    result.uncheck = getCheckboxesToUncheck(checkboxes, min, max);

    if (!result.uncheck.length) {
      result.uncheck = checkboxes;
      result.check = [];
    }

    return result;
  }

  function getCheckboxesToCheck (checkboxes, min, max) {
    return checkboxes.filter(c => {
      const value = parseFloat(c.value);
      return value >= min && value <= max;
    });
  }

  function getCheckboxesToUncheck (checkboxes, min, max) {
    return checkboxes.filter(c => {
      const value = parseFloat(c.value);
      return value < min || value > max;
    });
  }

  window.updateRangeFilters = function () {
    for (const filter of rangeFilters) {
      filter.render();
    }
  }

  window.updateActiveFilters = function () {
    const activeFacetsContainer = document.body.querySelector('.active-facets');
    const activeFilters = window.rangeFilters.filter(f => f.isActive);
    for (const filter of activeFilters) {
      if (activeFacetsContainer.querySelector(`[data-facet-range][data-name="${filter.name}"]`)) {
        continue;
      }
      
      const facets = activeFacetsContainer.querySelectorAll(`[data-from-slider][data-name="${filter.name}"]`);
      const facetClone = activeFacetsContainer.querySelector('[data-facet-template]').cloneNode(true);
      for (const facet of facets) {
        facet.remove();
      }

      facetClone.querySelector('.facet-title').innerText = filter.label;
      facetClone.querySelector('a').setAttribute('href', filter.urlToRemove);
      facetClone.style.display = '';
      facetClone.removeAttribute('data-facet-template');
      facetClone.setAttribute('data-name', filter.name);
      facetClone.setAttribute('data-facet-range', 'data-facet-range');
      activeFacetsContainer.prepend(facetClone);
    }
  }

  window.resetRangeFilter = function (name) {
    window.rangeFilters.filter(f => f.isActive && f.name === name).forEach(f => f.reset());
  }

  window.rangeFilters = initFilters();
  window.updateActiveFilters();
  
  document.body.addEventListener('mousedown', onMouseDown);
  document.body.addEventListener('touchstart', onMouseDown);

  document.body.addEventListener('mousemove', onMouseMove);
  document.body.addEventListener('touchmove', onMouseMove);

  document.body.addEventListener('mouseup', onMouseUp);
  document.body.addEventListener('touchend', onMouseUp);

  document.body.addEventListener('click', e => {
    if (e.target.matches('.facet-clear-all')) {
      window.rangeFilters.forEach(f => f.reset());
    }
    
    // if (!e.target.matches('.filter-choice__btn')) {
    //   return;
    // }

    // e.target.classList.toggle(ACTIVE_CHOICE_BUTTON_CLASS);

    // const value = e.target.dataset.value;
    // const checkboxes = [...e.target.closest('.details__content').querySelectorAll('input[type="checkbox"]')];
    // const targetCheckbox = checkboxes.find(c => c.value.split(' ')[0] === value);
    // targetCheckbox.checked = !targetCheckbox.checked;
    
    // dispatchChangeEvent(checkboxes[0]);
  });

  document.body.addEventListener('input', e => {
    if (!e.target.closest('.filter-range')) {
      return;
    }

    const min = parseFloat(e.target.getAttribute('min'));
    if (!isNaN(min) && parseFloat(e.target.value) < min) {
      e.target.value = min;
    }

    const max = parseFloat(e.target.getAttribute('max'));
    if (!isNaN(max) && parseFloat(e.target.value) > max) {
      e.target.value = max;
    }
  });

  document.body.addEventListener('change', e => {
    if (!e.target.closest('.filter-range')) {
      return;
    }

    e.preventDefault();
    e.stopImmediatePropagation();

    const value = parseFloat(e.target.value);
    if (isNaN(value)) {
      return;
    }
    
    const filter = getFilterState(e.target);
    if (e.target.hasAttribute('data-from-input')) {
      filter.from = value;
    } else if (e.target.hasAttribute('data-to-input')) {
      filter.to = value;
    }

    filter.fixValues();
    filter.render();
    selectCheckboxesBySlider(filter.slider);
  });

  document.body.addEventListener('keydown', e => {
    if (!e.target.closest('.filter-range')) {
      return;
    }

    if (e.code === 'Enter') {
      e.preventDefault();
      e.stopPropagation();

      if (e.target.matches('input[type="number"]')) {
        dispatchChangeEvent(e.target);
      }
    }
  });
})();